import {
  ClosureFormData,
  FullProject,
  ProjectService,
  calculateCountryServiceCost,
  taskStatusesConfig,
} from 'entities';

import { getFirst } from 'utils/array';

import { CountryService } from './types';

export function setVariablesToInitialValues(
  variables: ProjectService['costs'][string],
): ProjectService['costs'][string] {
  return variables.map(({ history, ...rest }) => ({
    ...rest,
    // history array starts with the first value repriced
    ...getFirst(history || []),
  }));
}

export function setCostsWithInitialValues(service: CountryService): CountryService {
  const { costs } = service;

  return {
    ...service,

    costs: setVariablesToInitialValues(costs),
  };
}

export function calculateServiceTotal({ costs, costCalculation }: CountryService): number {
  return calculateCountryServiceCost(costs, costCalculation);
}

export function calculateCountryTotal(services: CountryService[]): number {
  const total = services.reduce((acc, next) => acc + calculateServiceTotal(next), 0);

  return total;
}

export function buildFormData(project: FullProject): ClosureFormData {
  return {
    comment: '',

    servicesActualMetrics: project.services.map(({ costs, ...rest }) => ({
      ...rest,

      costs: Object.fromEntries(
        Object.entries(costs).map(([country, costVariables]) => [
          country,
          costVariables.map((cost) => ({ ...cost, value: '' })),
        ]),
      ),
    })),

    poNumber: {
      value: '',
    },

    emailChainAddition: false,

    outsourceEmailControl: project.services
      .filter(({ outsourced }) => outsourced)
      .map(({ id, name }) => ({ id, name, added: false })),

    canceledTasksPriceCheckControl: Object.fromEntries(
      project.tasks
        .filter(({ status }) => status === taskStatusesConfig.canceled.code)
        .map(({ id }) => [id, false]),
    ),
  };
}
